/**
 * Round 12 #779: the browser tab names the page the reader sees — "<page> · <platform name>" on a platform
 * page, "<page> · <App> · <platform name>" inside an app. The page is the visible title in <main> (the page
 * head's h1); the menu label is the fallback while a page has none (a long menu label such as Admin ›
 * Settings' sentence never wins over the page's own title).
 */
import { useEffect, useState } from 'react';

export function pageName(heading: string | null | undefined, menuLabel: string | null | undefined): string {
  const h = (heading ?? '').replace(/\s+/g, ' ').trim();
  return h || (menuLabel ?? '').trim();
}

/** The text of the first visible h1 inside `root`, kept current as the page renders. */
export function useMainHeading(root: HTMLElement | null, key: string): string | null {
  const [text, setText] = useState<string | null>(null);
  useEffect(() => {
    if (!root || typeof MutationObserver === 'undefined') return;
    const read = () => setText(root.querySelector('h1')?.textContent ?? null);
    read();
    const mo = new MutationObserver(read);
    mo.observe(root, { childList: true, subtree: true, characterData: true });
    return () => mo.disconnect();
  }, [root, key]);
  return text;
}
